// App.js
import React from 'react';
import Hero from './components/Hero';
import Projects from './components/Projects';
import About from './components/About';
import Stack from './components/Stack';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div>
      <Hero />
      <Projects />
      <About />
      <Stack />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;